import React from "react";
import { Box, Card, CardContent, Divider, Typography } from "@mui/material";

const RefundScheduledReceipt = ({
  orderReport,
  formatrefundCreditExpectedTime,
  formatpaymentTime,
  RefundedSuccess,
  totalRefundAmount
}) => {
  const refundInfo = orderReport?.data?.refundDetailInfoList?.[0];
  const items = orderReport?.data?.orderLineItem || [];

  const hrStyle = {
    marginTop: "1vw",
    marginBottom: "1vw",
    borderColor: "#E0E0E0",
    borderWidth: "0.5px"
  };

    const hrStyle1= {
    marginTop: "2vw",
    marginBottom: "1vw",
    borderColor: "#E0E0E0",
    borderWidth: "0.5px"
  };
    const hrStyle2 = {
    marginTop: "2vw",
    marginBottom: "1vw",
    borderColor: "#E0E0E0",
    borderWidth: "0.5px"
  };
  return (
    <>
      <div style={{ marginTop: "5vw" }}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            component="img"
            src={RefundedSuccess}
            alt="Order Success"
            sx={{ maxHeight: 155, borderRadius: 2, width: "68px", height: "68px" }}
          />
        </Box>

        <h1
          style={{
            color: "#01869E",
            fontSize: "20px",
            fontWeight: "600",
            textAlign: "center",
            marginTop: "2vw"
          }}
        >
          Refund Scheduled
        </h1>

        <div className="refund-box">
          <p style={{fontSize:"14px",marginBottom:"5vw"}}>
           You will receive your refund with in 40 minutes
            <span style={{ fontWeight: "600" }}>
        {/*       {refundInfo?.refundCreditExpectedTime
                ? formatrefundCreditExpectedTime
                : "40 minutes"} */}
            </span>
          </p>
        </div>
      </div>

      <Card sx={{ mb: 2 }} style={{ boxShadow: "none" }}>
        <CardContent>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            fontSize={12}
            color="#898C8E"
          >
            Amount to be Refunded:
            <span style={{ color: "#343A40" }}> ₹{totalRefundAmount}</span>
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Typography
            variant="body2"
            sx={{
              wordBreak: "break-word",
              fontWeight: "400",
              fontSize: "10px"
            }}
          >
            Amount will be refunded to source/ wallet/UPI/Card/Bank/Daalchini Wallet
          </Typography>
        </CardContent>
      </Card>

      <div className="rounded-lg p-3 mb-4">
        <p className="text-gray-800 font-semibold" style={{ fontSize: "12px" }}>
          <span style={{ color: "#898C8E" }}>Order:</span> {items.length} Items
        </p>
        <hr style={hrStyle1} />
        <div
          className="grid grid-cols-3 text-center mt-2 font-medium text-gray-600 text-xs border-gray-300 pb-1"
        >
          <div style={{ textAlign: "start" }}>Item(Count)</div>
          <div>Price Per Unit</div>
          <div style={{ marginRight: "2vw" }}>Status</div>
        </div>

        {items.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-3 text-center text-sm mt-1 text-gray-800"
            style={{ fontSize: "10px" }}
          >
            <div style={{ textAlign: "start" }}>
              {item.variantName.length > 20
                ? item.variantName.slice(0, 20) + "..."
                : item.variantName}{" "}
              ({String(item.itemQuantity).padStart(2, "0")})
            </div>
            <div>₹ {item.amount}</div>
            <div className="text-red-500 font-medium">
              {item.successQuantity > 0 && (
                <span
                  style={{
                    color: "#000000B2",
                    fontSize: "10px",
                    fontWeight: "700"
                  }}
                >
                  Success({item.successQuantity})
                </span>
              )}{" "}
              {item.failureQuantity > 0 && (
                <span
                  style={{
                    color: "#E65C5C",
                    fontSize: "10px",
                    fontWeight: "700"
                  }}
                >
                  Failed({item.failureQuantity})
                </span>
              )}{" "}
              {item.vendRemaining > 0 && (
                <span
                  style={{
                    color: "#F28618",
                    fontSize: "10px",
                    fontWeight: "700"
                  }}
                >
                  Pending({item.vendRemaining})
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-lg p-3">
        <p className="text-gray-800 font-semibold" style={{ fontSize: "12px" }}>
          <span style={{ color: "#898C8E" }}>Paid Amount:</span> ₹{" "}
          {refundInfo?.paidAmount}
        </p>
        <hr style={hrStyle2} />
        <p
          className="text-xs"
          style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}
        >
          {formatpaymentTime}
        </p>
        <p
          className="text-xs"
          style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}
        >
          Transaction ID: {refundInfo?.transactionId}
        </p>
        <p
          className="text-xs mt-2"
          style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}
        >
          Payment Method:{" "}
          <span className="font-medium">{refundInfo?.payMethod}</span>
        </p>
      </div>

     <div style={{padding:".75rem"}}> <hr style={hrStyle} /></div>
    </>
  );
};

export default RefundScheduledReceipt;
